import { render, staticRenderFns } from "./feriasServidor.vue?vue&type=template&id=0f6085bf&scoped=true&"
import script from "./feriasServidor.vue?vue&type=script&lang=js&"
export * from "./feriasServidor.vue?vue&type=script&lang=js&"
import style0 from "./feriasServidor.vue?vue&type=style&index=0&id=0f6085bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6085bf",
  null
  
)

export default component.exports